import { cn } from "@/lib/utils";

export function TagItem({
	label,
	active,
	onClick,
	type,
}: {
	label: string;
	active: boolean;
	onClick?: () => void;
	type?: "search" | "normal";
}) {
	// 使用标签名称生成随机颜色
	const colorIndex = label.charCodeAt(0) % 3;
	const bgColors = ["bg-c1", "bg-c2", "bg-bg3"];

	return (
		<span
			className={cn(
				"text-t2  text-xs rounded-full cursor-pointer transition-all duration-200",
				active && "!bg-main1 !text-white",
				bgColors[colorIndex],
				type === "search" ? "px-3 py-1.5" : "px-2 py-1",
			)}
			onClick={onClick}
		>
			{type === "search" && "#"}
			{label}
		</span>
	);
}

export function TagList({
	tags,
	isHover,
	className,
}: { tags: string[]; isHover: boolean; className?: string }) {
	return (
		<div
			className={cn(
				"flex flex-row gap-2 items-center flex-wrap ",
				isHover ? "max-h-14 overflow-hidden" : "max-h-6 overflow-hidden",
				className,
			)}
		>
			{tags.map((tag, _index) => (
				<TagItem
					key={`TagList-${tag}-${_index}`}
					label={tag}
					active={false}
					onClick={() => {}}
				/>
			))}
		</div>
	);
}
